import { ExclamationCircleFilled, SearchOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Dropdown,
  Form,
  Input,
  Row,
  Select,
  Space,
  Tooltip,
} from 'antd'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { RootDispatch } from '../../../../app/store'
import { EditableList } from '../../../../compnents/list/EditableList'
import { selectMenus, traceRoute } from '../../../../layouts/layoutSlice'
import { Dimen } from '../../../../models/dimen'
import {
  Patient,
} from '../../../../models/patient'
import { getGenderName } from '../../../../models/user'
import { GetPatientListParams } from '../../../../services/patient'
import { ThemeContext } from '../../../../theme/ThemeContext'
import { getAge } from '../../../../utils/StringUtils'
import { getChainPatientList, getPatientList, selectPatientPage } from '../patientListSlice'
import { decrypt } from '../../../../models/m'
import styles from '../mergePatientModal.module.css'
import { getChainListAsync } from '../../../warehouseStatement/allReport/warehouseChangeReport/warehouseChangeReportSlice'
interface PatientsProps {
  state: string,
}

const ChainPatientLists = (
  { state }: PatientsProps,
): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const inputRef = useRef<any>(null)

  const history = useHistory()

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const { Option } = Select

  const page = useSelector(selectPatientPage)

  const [pageLoading, setPageLoading] = useState(false) // 表格 loading

  const [params, setParams] = useState<GetPatientListParams>({ current: 1 })

  const [organizationData, setOrganizationData] = useState<any>([])

  useEffect(() => {
    sessionStorage.setItem(location.pathname, JSON.stringify({ state }))
  }, [state])

  const getPage = () => {
    setPageLoading(true)
    dispatch(
      getChainPatientList({
        ...params,
        labelName: params.labelName ? params.labelName : undefined,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if (params.name?.length == 9 && res.items.length == 1) {
          // 1112  不做跳转
          // navigateTo(res.items[0])
        }
      })
      .finally(() => setPageLoading(false))
  }
  useEffect(() => {
    getPage()
  }, [dispatch, params])

  useEffect(() => {
    dispatch(getChainListAsync())
      .then(unwrapResult)
      .then((res: any) => {
        setOrganizationData(res)
      })
  }, [])

  const navigateTo = (patient: Patient) => {
    dispatch(
      traceRoute({
        name: '门诊统计',
        path: '/Chainpatient/detail',
        query: `patientId=${patient.id}&tenantId=${patient.tenantId}`,
      })
    )
  }

  return (
    <Col
      style={{
        marginTop: 10,
        padding: '15px 15px 0 15px',
        height: 'calc(100% - 10px)',
        borderRadius: theme.br,
        backgroundColor: theme.pn,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Form
        form={form}
        autoComplete='off'
        onFinish={(values) => {
          setParams({
            ...params,
            ...values,
            tenantIds: values?.tenantIds?.join(','),
            current: 1,
          })
        }}
      >
        <Row
          style={{ marginBottom: 15 }}
          align='middle'
          justify='space-between'
        >
          <Space>
            <Form.Item name='name' noStyle>
              <Input
                ref={inputRef}
                allowClear
                style={{ width: 315 }}
                onChange={form.submit}
                placeholder='请输入姓名/手机号/助记码/病历号'
                prefix={<SearchOutlined style={{ color: theme.tc3 }} />}
              />
            </Form.Item>
            <Form.Item name='tenantIds' noStyle>
              <Select
                placeholder='机构名称'
                allowClear
                mode='multiple'
                dropdownClassName={styles.selectDropdown}
                style={{ minWidth: 300, maxWidth: 510 }}
                onChange={form.submit}
              >
                {organizationData?.map((v: any) => {
                  return (
                    <Option value={v?.id?.toString()} key={v?.id}>
                      {v?.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
            <Button type='primary' htmlType='submit' loading={pageLoading}>
              查询
            </Button>
          </Space>
        </Row>
      </Form>
      <EditableList<Patient>
        style={{ flex: 1 }}
        loading={pageLoading}
        page={page}
        columns={[
          {
            title: '序号',
            key: 'no',
            width: Dimen.Num,
            align: 'center',
            render: (_1, _2, i) => `${page.size * (page.current - 1) + i + 1}`,
          },
          {
            title: '机构名称',
            key: 'tenantName',
            width: '14rem',
            ellipsis: true,
            align: 'left',
            dataIndex: 'tenantName',
            render: function ShowActions(_, p) {
              return (
                <span>
                  {p?.tenantName || '-'}
                </span>
              )
            }
          },
          {
            title: '患者姓名',
            dataIndex: 'name',
            width: '12rem',
            ellipsis: true,
            align: 'center',
            render: function ShowActions(_, p) {
              return (
                <span>
                  {p?.name || '-'}
                </span>
              )
            }
          },
          {
            title: '病历号',
            key: 'id',
            width: '12rem',
            ellipsis: true,
            align: 'center',
            dataIndex: 'id',
          },
          {
            title: '性别',
            dataIndex: 'sex',
            width: '6rem',
            ellipsis: true,
            align: 'center',
            render: function ShowActions(_, p) {
              return getGenderName(p.sex)
            },
          },
          {
            title: '年龄',
            dataIndex: 'ageYear',
            width: '6rem',
            ellipsis: true,
            align: 'center',
            render: (_, r) => getAge(r?.ageYear, r?.ageMonth),
          },
          {
            title: '身份证号',
            dataIndex: 'idCardNumber',
            width: '16rem',
            ellipsis: true,
            align: 'center',
            render: (_, r) => {
              return r?.idCardNumber ? r?.idCardNumber : '-'
            },
          },
          {
            title: '联系电话',
            dataIndex: 'phone',
            width: '12rem',
            ellipsis: true,
            align: 'center',
            render: (_, r) => {
              return r?.phone ? decrypt(r?.phone) : '-'
            },
          },
          {
            title: '消费金额',
            dataIndex: 'totalPayAmount',
            width: '8rem',
            ellipsis: true,
            align: 'center',
            render: function ShowActions(_, p) {
              return p.totalPayAmount && p.totalPayAmount.toFixed(2)
            },
          },
          {
            title: '操作',
            key: 'actions',
            width: '8rem',
            align: 'center',
            render: function ShowActions(_, p) {
              return (
                <>
                  <Space>
                    <a onClick={() => navigateTo(p)}>详情</a>
                  </Space>
                </>
              )
            },
          },
        ]}
        onChangePage={(current, size) =>
          setParams({ ...params, current, size })
        }
        onRow={(record) => ({
          onDoubleClick: () => {
            navigateTo(record)
          },
        })}
      />
    </Col>
  )
}

export const ChianPatients = forwardRef(ChainPatientLists)

